const getters = {
  UserId: state => state.user.Id,
  JobNo: state => state.user.JobNo,
  Name: state => state.user.Name,
  NickName: state => state.user.NickName,
  Avatar: state => state.user.Avatar,
  Level: state => state.user.Level,
  Token: state => state.user.Token,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js